import { SecondaryButton, TertiaryButton } from "@shared/buttons";
import { Modal } from "@shared/modal";
import { downloadCsv } from "@utils/csv";

interface ExportToCsvModalProps {
  table: any;
  dailyDataTable: any;
  setExportToCsvModalOpen: (arg0: boolean) => void;
  exportToCsvModalOpen: boolean;
}

export const ExportToCsvModal = ({
  table,
  dailyDataTable,
  setExportToCsvModalOpen,
  exportToCsvModalOpen,
}: ExportToCsvModalProps) => {
  return (
    <>
      <SecondaryButton onClick={() => setExportToCsvModalOpen(true)}>
        EXPORT TO CSV
      </SecondaryButton>
      <Modal
        isOpen={exportToCsvModalOpen}
        onClose={() => setExportToCsvModalOpen(false)}
        hideCloseButton
      >
        <SecondaryButton
          className="my-2"
          onClick={() =>
            downloadCsv("Sales", "north-beam-sales-report.csv", table)
          }
        >
          Export Aggregated Data
        </SecondaryButton>
        <br />
        <SecondaryButton
          className="mb-3"
          onClick={() =>
            downloadCsv(
              "DailySalesData",
              "north-beam-sales-daily-report.csv",
              dailyDataTable,
            )
          }
        >
          EXPORT DATA BROKEN DOWN BY DAY
        </SecondaryButton>
        <br />
        <TertiaryButton onClick={() => setExportToCsvModalOpen(false)}>
          CLOSE
        </TertiaryButton>
      </Modal>
    </>
  );
};
